import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { TwitterRoutingModule } from './twitter-routing.module';
import { TwitterService } from './Services/twitter.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TwitterPostDetailsComponent } from './Components/twitter-post-details/twitter-post-details.component';
import { TwitterCommentsComponent } from './Components/twitter-comments/twitter-comments.component';
import { TwitterPostsComponent } from './Components/twitter-posts/twitter-posts.component';



@NgModule({
  declarations: [
    TwitterPostsComponent,
    TwitterPostDetailsComponent,
    TwitterCommentsComponent,
  ],
  providers: [
    TwitterService,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    TwitterRoutingModule,
    FontAwesomeModule,
  ]
})
export class TwitterModule { }